import { environment } from './../../../../environment/environment';
import { CompanyService } from './../../../core/services/company/company.service';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { SubscriptionService } from '@core/services/subscription.service';
@Component({
  selector: 'app-details-entreprises',
  templateUrl: './details-entreprises.component.html',
  styleUrls: ['./details-entreprises.component.css'],
})
export class DetailsEntreprisesComponent {
  /* object */
  esnDetails: any;
  /* string */
  id!: string;
  /* formGroup */
  companyDetailsForm: FormGroup = this.createCompanyDetailsForm();
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  separateDialCode: boolean = false;
  selectedCountryCode: string = 'FR';

  /* short url */
  siteweb_link: any;
  shortenedUrl = '';
  currentUser: any;
  companyRoleId: any;

  url: string = environment.baseUrl + '/api';
  listReviewCompany: any;
  listDefaultReview: any;
  type = [
    { id: '2', name: 'ESN' },
    { id: '3', name: 'Client Final' },
    { id: '4', name: 'Cabinet de Recrutement' },
  ];
  societe: any;
  idCampany!: number;
  file: any;
  selectedImage: any;

  fileName!: string;
  fileExtention: string = '';
  fileError: string = '';
  logo: any;
  dataEsn: any;
  email: any;
  nameEsn: any;
  hasActiveSubscription:any;
  typee:any
  idCallOffer!: number;
  modalRef?: BsModalRef;
  /* number */
  totalItems!: number;
  itemsPerPage: number = 20;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  total_avg_stars: any;
  showBoxResponseCompany = false;
  showBoxDefaultResponse = true;
  createform: FormGroup = this.createCompanyDetailsForm();
  phoneForm!: FormGroup;
  reviewCompany: any;
  review : number=0;
  reviewCandidat: any;
  listCandidatReviewDetails:any
  connectedUser: string | null | number =this.localStorageService.getData('userConnected');
  typeintervenant: string | null | number =this.localStorageService.getData('typeintervenant');

  isUnSubscribed: boolean = true
  reviewnote:any
  constructor(
    private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private subscriptionService: SubscriptionService

  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.isUnSubscribed = this.unSubscribedEsn()
    this.getId();
    this.getcurrentUser()
   
  }

  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
        this.getCompanyById()
        this.getReviewCompany()
        this.getReviewCandidat()
      },
    });
  }
  contactResponsableNavigation(id: any) {
    !this.isUnSubscribed && this.router.navigate(['/contact', { idResponsable: id , Type:this.typee }]);
  }
  VoiroffreNavigation(id: any) {
    this.router.navigate(['/entreprises/offre-entreprise', { id: id }]);
  }
  getCandidatReviewDetails(idDonneur?:any) {
    this.spinner.show()
    this.companyService.getCandidatReviewById(idDonneur, this.id ).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        if (res.status == 200) {
         
          this.listCandidatReviewDetails = res
          this.spinner.hide()
        }
      },
      error: () => {
        this.spinner.hide()
    
      }
    })
  }
  getTypeName(typeId: string): string {
    switch (typeId) {
      case '2':
        return 'ESN';
      case '3':
        return 'Client Final';
      case '4':
        return 'Cabinet de Recrutement';
      default:
        return '---';
    }
  }

  getCompanyById() {
    this.spinner.show();
    this.companyService
      .getCompanydetail(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
         
          this.esnDetails = res.data;
          this.logo = res.data[0].logo;
          this.dataEsn = res.data[0];
         this.hasActiveSubscription = res.data[0].hasActiveSubscription;
          this.nameEsn = res.data[0].name;
          this.email = res.data[0].ContactEmail;
          this.typee=res.data[0].type
          this.companyDetailsForm = this.createCompanyDetailsForm(res.data[0]);
          this.companyDetailsForm
            .get('country')
            ?.setValue(
              res.data[0]?.country == 'null' ? null : res.data[0].country
            );
          this.companyDetailsForm?.get('city')
            ?.setValue(res.data[0]?.city == 'null' ? null : res.data[0].city);
          this.phoneForm?.get('phone')?.setValue(this.companyDetailsForm.get('phone_number')?.value);
          console.log('logo', this.logo);
          this.companyDetailsForm = this.createCompanyDetailsForm(
            this.esnDetails
          );
           this.spinner.hide();
          // this.companyDetailsForm = this.DetailsForm({ created_at: this.datePipe.transform(createdAt, 'dd/MM/yyyy') });
        },
        error: (err) => {
          console.log('error', err);
          this.spinner.hide();
        },
      });
  }

  /* create add company details form */
  createCompanyDetailsForm(data?: any) {
    return this.formBuilder.group({
      id: [data ? data.id : null, [Validators.required]],
      name: [data ? data.name : '', [Validators.required]],
      type: [data ? data.type : null, [Validators.required]],
      domain: [data ? data.domain : '', [Validators.required]],
      number_of_salaries: [
        data ? data.number_of_salaries : '',
        [Validators.required],
      ],
      note: [data ? data.note : null, [Validators.required]],
      // created_at: [data ? data.created_at : null, [Validators.required]],
      //  employee:[data ? data.employee[0].user.first_name : ""],
      //  employeeprenom:[data ? data.employee[0].user.last_name : ""],
      email: [data ? data.user?.email : '', [Validators.required]],
      logo: [data ? data.logo : ''],
      linkedin_link: [data ? data.linkedin_link : '', [Validators.required]],
      website_link: [data ? data.website_link : '', [Validators.required]],
      phone_number: [
        data ? data.user?.phone_number : '',
        [Validators.required],
      ],
      adresse: [data ? data.city : null, [Validators.required]],
      addre: [data ? data.country : null, [Validators.required]],
    });
  }
  openModalDetails(template: TemplateRef<any>,idDonneur:any) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static'});
    console.log("idDonneur",idDonneur)
    this.getCandidatReviewDetails(idDonneur)
  }
  closeModalDetails() {
    this.modalRef!.hide();
  }
  getReviewCompany() {
    this.spinner.show();
    this.companyService
      .getReviewCompany(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
     
          this.reviewCompany = res;
          this.reviewnote=this.reviewCompany['avrage_note_total'].average_note_total
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /*get  candidat */
  getReviewCandidat() {
    this.spinner.show();
    this.companyService
      .getReviewCandidat(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.reviewCandidat = res.data.data;
          this.spinner.hide();

        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  navigatToDetailsCandidat(id: any) {   
    this.router.navigate([
      '/candidats/profilecandidatesn',id]);
  }
  show(data: any) {
    this.idCallOffer = data.id;
    this.createform = this.createCompanyDetailsForm(data);
    this.createform.get('name')?.setValue(data.name);

  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
  }
  isClient(): boolean {
    return this.companyRoleId!= undefined ? this.companyRoleId.includes('9')  : false;
  }
  isEsnNotSubscribed(): boolean {    
    return this.companyRoleId!= undefined ? this.companyRoleId.includes('8')  : false;
  }
  isEsnSubscribed(): boolean {
    return this.companyRoleId!= undefined ? this.companyRoleId.includes('7')  : false;
  }

/**
 * Redirects to a specified URL. Opens the URL in a new tab if `isBlank` is `true`.
 * 
 * @param url - The URL to redirect to.
 * @param isBlank - If `true`, opens the URL in a new tab; otherwise, navigates in the same tab.
 */
  redirectTo(url: string, isBlank: boolean): void {
    if (url) {
      const fullUrl = url.startsWith('http') ? url : `https://${url}`;
      window.open(fullUrl, '_blank','noopener,noreferrer');
    }
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  unSubscribedEsn(): boolean {
    return this.subscriptionService.unSubscribedEsn();
  }

}
